import { CompanyInfo, InventoryItem, ServiceTicket, StockMovement } from '../types';

export const defaultCompanyInfo: CompanyInfo = {
  name: 'Teknik Servis',
  phone: '',
  email: '',
  address: '',
  taxOffice: '',
  taxNumber: '',
  terms: '1. Cihaz teslim tarihinden itibaren 30 gün içinde alınmayan cihazlardan firmamız sorumlu değildir.\n2. Sıvı temaslı ve darbe görmüş cihazlarda garantimiz bulunmamaktadır.\n3. Şifre verilmeyen cihazlarda sistem testi yapılamaz.',
  adminUsername: 'admin',
  securityQuestion: 'Yedek Kurtarma Kodu / Gizli Cevap',
  passwordVersion: '1',
};

export const defaultDeviceTypes: string[] = [
  'Telefon',
  'Laptop',
  'Masaüstü PC',
  'Tablet',
  'Oyun Konsolu',
  'Televizyon',
  'Akıllı Saat',
  'Yazıcı / Tarayıcı',
  'Küçük Ev Aleti',
  'Diğer',
];

export const defaultDeviceBrands: string[] = [
  'Apple',
  'Samsung',
  'Xiaomi',
  'Huawei',
  'Asus',
  'Lenovo',
  'HP',
  'Dell',
  'Acer',
  'Monster',
  'Casper',
  'LG',
  'Sony',
  'Philips',
  'Beko',
  'Arçelik',
  'Vestel',
  'Bosch',
  'Dyson',
  'Canon',
  'Epson',
  'JBL',
  'Logitech',
  'Oppo',
  'Realme',
  'Vivo',
  'Honor',
  'TCL',
  'Toshiba',
  'MSI',
  'General Mobile',
  'Reeder',
  'PlayStation',
  'Xbox',
  'Nintendo',
  'Diğer',
];

export const defaultInventoryCategories = [
  'Diğer',
];

export const initialInventoryItems: InventoryItem[] = [];

export const initialStockMovements: StockMovement[] = [];

export const initialTickets: ServiceTicket[] = [];
